// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorAccountPharmacyBenefitModelResponse {
    static getAttributeTypeMap() {
        return PayorAccountPharmacyBenefitModelResponse.attributeTypeMap;
    }
}
PayorAccountPharmacyBenefitModelResponse.discriminator = undefined;
PayorAccountPharmacyBenefitModelResponse.additionalProperties = false;
PayorAccountPharmacyBenefitModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PayorAccountPharmacyBenefitModel"
    },
];
//# sourceMappingURL=payorAccountPharmacyBenefitModelResponse.js.map